import { useEffect, useRef, useState } from 'react';

export default function useVisibilityAwareLazyLoader(
  loadAfterMilliseconds: number = 1000,
  observerArgs?: IntersectionObserverInit,
) {
  const nodeRef = useRef<HTMLElement | null>(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  const args = { threshold: 0, ...observerArgs };

  useEffect(() => {
    const node = nodeRef.current;
    let loadTrigger: ReturnType<typeof setTimeout>;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        loadTrigger = setTimeout(() => {
          setShouldLoad(true);

          if (node) {
            observer.unobserve(node);
          }
        }, loadAfterMilliseconds);
      } else {
        clearTimeout(loadTrigger);
      }
    }, args);

    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
        clearTimeout(loadTrigger);
      }
    };
  }, [loadAfterMilliseconds]);

  return { nodeRef, shouldLoad };
}
